import axios from 'axios'

// axios config
axios.defaults.baseURL = process.env.REACT_APP_API_URL
axios.defaults.withCredentials = true

export const axiosInstance = axios.create()
